<template>
  <div>
    <div
      class="bg-fade-primary-dark-8 p-3 display-4"
      v-html="day.detailedForecast"
    />
  </div>
</template>

<script>
export default {
  name: 'DetailedWeather',
  props: {
    day: {
      type: Object,
      required: true,
    },
  },
};
</script>
